<template>
  <div class="MemberStudy">
    <el-tabs class="courseTab" v-model="activeName">
      <el-tab-pane label="系统课" name="0">
        <TabPaneContent :type="0" />
      </el-tab-pane>
      <el-tab-pane v-if="isCzScenes && hasInteractiveCourse" label="互动课" name="1" lazy>
        <TabPaneContent :type="0" isInteractive />
      </el-tab-pane>
      <el-tab-pane label="赠课" name="2" lazy>
        <TabPaneContent :type="1" />
      </el-tab-pane>
      <el-tab-pane label="资料课" name="3" lazy>
        <!-- 激活时初始化以保证 学习状态（已学、上次学到）及时更新 -->
        <TabPaneContent v-if="activeName === '3'" :type="2" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { triggerLoaded } from '@/components/LoadContainer.vue';
import TabPaneContent from './TabPaneContent.vue';
const COURSE_TYPE = [0, 11, 1, 2];
export default {
  name: 'MemberStudy',
  components: {
    TabPaneContent,
  },

  data() {
    return {
      activeName: '0',
      isCzScenes: location.hostname.includes('czmstt'),
      // isCzScenes: true,
      hasInteractiveCourse: false,
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler(newVal) {
        this.$webSeeSendTrack({
          event_id: 'my_study_tab_click',
          event_type: 'click',
          data: {
            course_type: COURSE_TYPE[newVal],
          },
        });
      },
    },
  },
  async created() {
    triggerLoaded(this);
  },
  async mounted() {
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'my_courses_page_show',
      });
    }, 500);
    if (this.isCzScenes) {
      const data = await this.$http.get('/api/app/myStudy/v2/1', {
        biz_type: 11,
        course_gift_type: 0,
      });
      if (data.courseList.length > 0) {
        this.hasInteractiveCourse = true;
      }
      //  0, //系统课
      //  1, //免费课
      //  2, //资料课
      //  11,// 互动课
      this.$webSeeSendTrack({
        event_id: 'my_study_tab_page_show',
        data: {
          course_types: [0, 1, 2, 11],
        },
      });
    } else {
      this.$webSeeSendTrack({
        event_id: 'my_study_tab_page_show',
        data: {
          course_types: [0, 1, 2],
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.MemberStudy {
  .courseTab {
    ::v-deep {
      .el-tabs__header {
        padding: 13px 32px 13px 8px;
        border-radius: 8px;
        background: #fff;
        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }
          .el-tabs__active-bar {
            display: none;
            border-radius: 20px;
            background: #f55;
          }
          .el-tabs__item {
            position: relative;
            height: 30px;
            margin: 0 16px;
            padding: 0 8px;
            line-height: 30px;
            color: #706e79;
            font-size: 16px;
            &.is-active {
              color: #000 !important;
              font-weight: 500;
              &::after {
                content: '';
                position: absolute;
                display: inline-block;
                bottom: 0;
                height: 2px;
                width: 24px !important;
                border-radius: 20px;
                background: #f55;
                left: 50% !important;
                transform: translateX(-50%) !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
